import { MEETING_LINK_ZOOM_PLATFORM } from '../links';
import { showSmbButton } from './show-smb-button';
import { resolveSmbButton } from './smb-button';
export function resolveDashboard(selectedLocale, accessLevel, company, admin, handleCheckout) {
    const isEnglish = selectedLocale === 'en';
    const isFromQuebec = company.province === 'QC';
    const revenue = company.annual_revenue;
    if (accessLevel === 'custom') {
        if (isEnglish) {
            return {
                title: 'Talk to my account manager',
                link: (admin === null || admin === void 0 ? void 0 : admin.meeting_link_en) || '',
            };
        }
        else {
            return {
                title: 'Parler à mon gestionnaire de compte',
                link: (admin === null || admin === void 0 ? void 0 : admin.meeting_link_fr) || '',
            };
        }
    }
    if (accessLevel === 'premium' || accessLevel === 'expert') {
        if (showSmbButton(selectedLocale, accessLevel, company)) {
            return resolveSmbButton(selectedLocale, company);
        }
        if (isEnglish) {
            return {
                title: 'Sign me up',
                link: MEETING_LINK_ZOOM_PLATFORM,
            };
        }
        else {
            return {
                title: "Je m'inscris",
                link: MEETING_LINK_ZOOM_PLATFORM,
            };
        }
    }
    if (isEnglish) {
        if (isFromQuebec) {
            if (revenue === '500k' ||
                revenue === '1m' ||
                revenue === '2m' ||
                revenue === '5m' ||
                revenue === '10m' ||
                revenue === '20m' ||
                revenue === '25m' ||
                revenue === '50m' ||
                revenue === '100m' ||
                revenue === '100m+') {
                return {
                    title: 'Sign me up',
                    action: handleCheckout,
                    isLocked: true,
                };
            }
        }
        if (!isFromQuebec) {
            if (revenue === '500k' ||
                revenue === '1m' ||
                revenue === '2m' ||
                revenue === '5m' ||
                revenue === '10m' ||
                revenue === '20m' ||
                revenue === '25m' ||
                revenue === '50m' ||
                revenue === '100m' ||
                revenue === '100m+') {
                return {
                    title: 'Sign me up',
                    action: handleCheckout,
                    isLocked: true,
                };
            }
        }
    }
    if (!isEnglish) {
        if (isFromQuebec) {
            if (revenue === '500k' ||
                revenue === '1m' ||
                revenue === '2m' ||
                revenue === '5m' ||
                revenue === '10m' ||
                revenue === '20m' ||
                revenue === '25m' ||
                revenue === '50m' ||
                revenue === '100m' ||
                revenue === '100m+') {
                return {
                    title: "Je m'inscris",
                    action: handleCheckout,
                    isLocked: true,
                };
            }
        }
        if (!isFromQuebec) {
            if (revenue === '500k' ||
                revenue === '1m' ||
                revenue === '2m' ||
                revenue === '5m' ||
                revenue === '10m' ||
                revenue === '20m' ||
                revenue === '25m' ||
                revenue === '50m' ||
                revenue === '100m' ||
                revenue === '100m+') {
                return {
                    title: "Je m'inscris",
                    action: handleCheckout,
                    isLocked: true,
                };
            }
        }
    }
    return {
        title: isEnglish ? 'Sign up' : "Je m'inscris",
        isLocked: true,
    };
}
